module.exports = __webpack_public_path__ + "img/djsBanner.acf4b8b5.png";